import * as React from "react";
import { typeCompact14Medium } from "@traceair/tds";
import { style, classes } from "typestyle";
import config from "../../config";
import { blue } from "../Generics/_colors";

const rootCN = style({
  pointerEvents: "auto",
  cursor: "pointer",
  background: "white",
  padding: "8px 12px",
  borderRadius: "8px",
  boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  flex: "none",
});

const checkboxCN = style({
  width: "24px",
  height: "24px",
  marginRight: "12px",
  borderRadius: "8px",
  boxSizing: "border-box",
  flex: "none",
});

const offCN = style({
  border: "2px solid black",
});

const onCN = style({
  backgroundColor: blue,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

interface IShowFlightMarkerLabelsButtonProps {
  isOn: boolean;
  onClick(): void;
}

function ShowFlightMarkerLabelsButton({
  onClick,
  isOn,
}: IShowFlightMarkerLabelsButtonProps) {
  return (
    <div className={classes("show-labels-button", rootCN)} onClick={onClick}>
      {isOn ? (
        <div className={classes(checkboxCN, onCN)}>
          <img src="icon-check-mark.svg" />
        </div>
      ) : (
        <div className={classes(checkboxCN, offCN)} />
      )}
      <div className={typeCompact14Medium}>
        {config.language === "ru" ? "Названия опознаков" : "Show Labels"}
      </div>
    </div>
  );
}

export default ShowFlightMarkerLabelsButton;
